import emailjs from "@emailjs/browser";

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
const SUPPORT_EMAIL = process.env.REACT_APP_SUPPORT_EMAIL;
const BRAND_NAME = process.env.REACT_APP_BRAND_NAME || "Sky High NTB";
const BASE_URL = process.env.REACT_APP_BASE_URL || "https://skyhighntb.com";

const generateTransferSupportNotificationHTML = (transferData) => {
  const adminLink = `${BASE_URL}/userdetail/${transferData.userId}`;
  const amount = typeof transferData.amount === 'number' ? transferData.amount.toFixed(2) : transferData.amount;
  
  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 20px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>New Transfer</h1>
        </div>
        <div class="content">
          <p>A new transfer has been made on ${BRAND_NAME}.</p>
          
          <div class="info-box">
            <p><span class="label">Sender:</span> ${transferData.sender}</p>
            <p><span class="label">Sender Account:</span> ${transferData.senderAccount}</p>
            <p><span class="label">Beneficiary:</span> ${transferData.beneficiary}</p>
            <p><span class="label">Bank Name:</span> ${transferData.bankName}</p>
            <p><span class="label">Beneficiary Account:</span> ${transferData.beneficiaryAccount}</p>
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Date:</span> ${transferData.date}</p>
            <p><span class="label">Type:</span> ${transferData.type}</p>
            <p><span class="label">Status:</span> ${transferData.status}</p>
          </div>
          
          <div style="text-align: center;">
            <a href="${adminLink}" class="btn">Moderate Transaction</a>
          </div>
        </div>
      </div>
    </body>
    </html>
  `;
};

const generateTransferConfirmationHTML = (transferData) => {
  const trackLink = `${BASE_URL}/transactions/${transferData.userId}/${transferData.transactionIndex}`;
  const amount = typeof transferData.amount === 'number' ? transferData.amount.toFixed(2) : transferData.amount;

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <style>
        .header { background: linear-gradient(to right, #8b0000, #dc143c); color: #ffffff; padding: 10px; text-align: center; border-radius: 10px 10px 0 0; }
        .content { padding: 10px; color: #333; }
        .info-box { background: #f8f9fa; padding: 20px; border-radius: 8px; margin: 20px 0; }
        .info-box p { margin: 12px 0; }
        .label { font-weight: bold; color: #2C3D4F; }
        .amount { font-size: 28px; font-weight: bold; color: #2C3D4F; }
        .btn { display: inline-block; padding: 12px 30px; background: #8b0000; color: gold; text-decoration: none; border-radius: 5px; margin: 20px 0; }
      </style>
    </head>
    <body>
      <div class="container">
        <div class="header">
          <h1>Transfer Initiated</h1>
        </div>
        <div class="content">
          <p>Hello <strong>${transferData.sender}</strong>,</p>
          <p>Your transfer was successfully and is being processed.</p>
          
          <div class="info-box">
            <p><span class="label">Amount:</span> $${amount}</p>
            <p><span class="label">Beneficiary:</span> ${transferData.beneficiary}</p>
            <p><span class="label">Bank Name:</span> ${transferData.bankName}</p>
            <p><span class="label">Account Number:</span> ${transferData.beneficiaryAccount}</p>
            <p><span class="label">Date:</span> ${transferData.date}</p>
            <p><span class="label">Status:</span> ${transferData.status}</p>
          </div>
          
          <p>Track your transaction status using the link below:</p>
          
          <div style="text-align: center;">
            <a href="${trackLink}" class="btn">Track Transaction</a>
          </div>
          
        </div>
      </div>
    </body>
    </html>
  `;
};

export const sendTransferNotificationToSupport = async (transferData) => {
  console.log("📧 Sending transfer support notification...", { SUPPORT_EMAIL, transferData });
  try {
    const html = generateTransferSupportNotificationHTML(transferData);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: "Admin",
        user_email: SUPPORT_EMAIL,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Transfer support notification sent:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending transfer support notification:", error);
    return false;
  }
};

export const sendTransferConfirmationToUser = async (userEmail, transferData) => {
  console.log("📧 Sending transfer confirmation to user...", { userEmail, transferData });
  try {
    const html = generateTransferConfirmationHTML(transferData);
    const response = await emailjs.send(
      SERVICE_ID,
      TEMPLATE_ID,
      {
        user_name: transferData.sender,
        user_email: userEmail,
        html: html,
      },
      PUBLIC_KEY
    );
    console.log("✅ Transfer confirmation sent to user:", response);
    return true;
  } catch (error) {
    console.error("❌ Error sending transfer confirmation:", error);
    return false;
  }
};

export const sendTransferEmails = async (userEmail, transferData) => {
  const supportResult = await sendTransferNotificationToSupport(transferData);
  const userResult = await sendTransferConfirmationToUser(userEmail, transferData);
  return supportResult && userResult;
};